const MAX_INT_32 = 2 ** 31 - 1; // 2147483647
export const VALUE_MAX = MAX_INT_32;

type Trial = {
    enabled: boolean;
    value: number;
    expirationDate: number;
};

export type Module = {
    key: string;
    label: string;
    value: number;
    onPrem: { enabled: boolean; trial?: Trial };
    cloud: { enabled: boolean; trial?: Trial };
    learnMoreLink?: string;
    getAccessLink?: string;
    getCloudLink?: string;
    exportFilePath?: string;
};

export type ModuleExtraData = {
    usage?: number;
    shouldShowUsage?: boolean;
    exportFilePath?: string;
    learnMoreLink?: string;
};
